// Stub — blocked by PASO-829 (partner_id not yet created)
export const GqlProvider = ({children}: {children?: React.ReactNode}) => (
	<>{children}</>
);
